import React from "react";
import {
  DateTimeField,
  MoneyField,
  StatusField,
} from "./components/CustomColumns";
import { OfferingNameChips } from "features/PaymentLinks/modules/ExistingPaymentLinks/components/OfferingNameChip/OfferingNameChip";
import {
  OFFER_TARGET_TYPE,
  OFFER_TARGET_TYPE_OPTIONS,
  OFFER_TYPE,
} from "ui/modules/LimitedOfferModalContent/constants";
import { PRICE_REGION_CHOICES } from "features/PaymentLinks/modules/PaymentLinksTransactions/constants/PaymentLinksTransactions.constants";
import {
  formatRevenue,
  SHOW_TOTAL_VISITORS,
} from "features/Common/utils/common.utils";

export const columnConfig = (classes) => [
  {
    field: "title",
    headerName: "Offering name",
    showInCard: true,
    emptyField: "N/A",
    noWrap: true,
    sortable: false,
    ellipsis: true,
    maxCharCount: 30,
  },
  {
    field: "target_type",
    headerName: "Created for",
    emptyField: "N/A",
    noWrap: true,
    sortable: false,
    ellipsis: true,
    maxCharCount: 30,
    valueFormatter: (record) =>
      OFFER_TARGET_TYPE_OPTIONS.find(
        (option) => option.value === record.target_type
      )?.label || "N/A",
  },
  {
    field: "listing_name",
    headerName: "Page(s)",
    emptyField: "N/A",
    noWrap: true,
    sortable: false,
    ellipsis: true,
    maxCharCount: 30,
    valueFormatter: formatOfferingName,
  },
  {
    field: "price",
    headerName: "Offer Price",
    showInCard: true,
    emptyField: "N/A",
    noWrap: true,
    sortable: false,
    valueFormatter: (record) =>
      record?.metadata?.offer_type === OFFER_TYPE.PERCENTAGE ? (
        `${record?.metadata?.discount_percentage}%${
          record?.region === PRICE_REGION_CHOICES.INTERNATIONAL
            ? " (International)"
            : ""
        }`
      ) : (
        <MoneyField noRightMargin record={record} source="price" />
      ),
  },
  ...(SHOW_TOTAL_VISITORS
    ? [
        {
          field: "total_visitors",
          headerName: "No. of visitors",
          emptyField: "N/A",
          noWrap: true,
          sortable: false,
        },
      ]
    : []),
  {
    field: "total_leads",
    headerName: "No. of leads",
    emptyField: "N/A",
    noWrap: true,
    sortable: false,
  },
  {
    field: "total_bookings",
    headerName: "No. of bookings",
    emptyField: "N/A",
    noWrap: true,
    sortable: false,
  },
  {
    field: "total_revenue",
    headerName: "Total revenue",
    emptyField: "N/A",
    noWrap: true,
    sortable: false,
    valueFormatter: (record) => formatRevenue(record?.total_revenue),
  },
  {
    field: "total_discount",
    headerName: "Total discount given",
    showInCard: true,
    emptyField: "N/A",
    sortable: false,
    noWrap: true,
    valueFormatter: (record) => formatRevenue(record?.total_discount),
  },
  {
    field: "end_datetime",
    headerName: "End date",
    emptyField: "N/A",
    noWrap: true,
    sortable: false,
    valueFormatter: (record) => (
      <DateTimeField record={record} source="end_datetime" />
    ),
    columnClassName: classes.endDate,
  },
  {
    field: "status",
    headerName: "Status",
    valueFormatter: (record) => <StatusField record={record} />,
    align: "left",
    hidden: true,
    fixed: "right",
  },
];

export const filterConfig = [
  {
    source: "title",
    placeholder: "Offer Name",
    type: "input",
  },
  {
    source: "listing__title",
    placeholder: "Offering Name",
    type: "input",
  },
  {
    source: "status",
    placeholder: "All Status",
    type: "dropdown",
    options: [
      { label: "Active", value: 1 },
      { label: "Scheduled", value: 0 },
      { label: "Expired", value: 2 },
    ],
  },
];

export const tableChipsFormatter = (filter, value) => {
  switch (filter) {
    case "title__icontains":
      return `Offer Name: ${value}`;
    case "listing__title__icontains":
      return `Offering Name: ${value}`;
    case "status":
      return `Status: ${value}`;
    default:
      return undefined;
  }
};

const formatOfferingName = (record) => {
  let names;
  if (record?.target_type === OFFER_TARGET_TYPE.SPECIFIC_OFFERING) {
    names = record?.listing_uids?.map((l) =>
      typeof l === "string" ? l : l.title
    );
  } else if (record?.target_type === OFFER_TARGET_TYPE.SPECIFIC_PAYMENT_PAGE) {
    names = record?.dynamic_link_uuids?.map((d) =>
      typeof d === "string" ? d : d.title
    );
  }
  if (!names?.length) {
    names = (record?.listing_name || "").split(", ");
  }
  return <OfferingNameChips listingNames={names} />;
};
